import { parseEnv } from '@/helpers/route-utils';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import * as z from 'zod/v4';

export const Route = createFileRoute('/_auth/$env/users')({
  validateSearch: zodValidator(
    z.object({
      search: z.string().optional().default(''),
      id: z.string().optional(),
      mode: z.enum(['new', 'edit']).optional(),
      page: z.number().optional().default(1),
      pageSize: z.number().optional().default(10),
      translationSidebarOpen: z.boolean().optional(),
    }),
  ),
  params: parseEnv(),
  beforeLoad: ({ context }) => {
    if (context.auth.user?.role !== 'admin') {
      context.toast({
        title: 'Not authorized',
        description: 'You are not authorized to access this page',
        variant: 'destructive',
        duration: 5000,
      });
      return redirect({ to: '/' });
    }
  },
});
